import React, { Component } from 'react';
import { func, object } from 'prop-types';
import { contains, map } from 'ramda';

// Redux
import { connect } from 'react-redux';
import {
  getProfile,
  updateProfile,
  updatePassword,
} from '../../../../actions/profile/profileActions';
import * as ProfileTypes from '../../../../actions/profile/types';

import LoadingState from '../../../LoadingState';
import LoginInfo from './LoginInfo';
import ChangePassword from './ChangePassword';
import ContactInfo from './ContactInfo';
import ContactInfoBasic from './ContactInfoBasic';
import AdditionalInfo from './AdditionalInfo';

import cx from 'classnames';
import s from './Profile.css';


class Profile extends Component {
  static propTypes = {
    loadingState: object,
    getProfile: func,
    profile: object,
    updatePassword: func,
    updateProfile: func,
  };

  constructor(props) {
    super(props);

    this.state = {
      username: '',
    };

    // Values of form labels
    this.labels = {
      email: 'Email address',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmNewPassword: 'Confirm new password',
      home: 'Home number',
      cell: 'Cell number',
      language: 'Preferred spoken language',
      location: 'Preferred office location',
      timeZone: 'Time zone',
    };
  }

  // Setting state from props is (generally) a React anti-pattern. However, the exception here is that the profile prop object
  // is acting as seed data for this component's internally-controlled state.
  componentWillReceiveProps(nextProps) {

    if (nextProps.profile) {
      const {
        contactMethods,
        destinations,
        languages,
        locations,
        optOut,
        timeZones,
        username,
      } = nextProps.profile;

      // Top level profile response
      this.setState({
        username,
        optOut,
      });

      // ContactInfo
      if (destinations) {
        const { email, home, cell } = nextProps.profile.destinations;

        this.setState({
          email,
          home,
          cell,
        });
      }

      // AdditionalInfo
      if (languages && locations && timeZones) {

        this.setState({
          contactMethod: contactMethods.default,
          contactMethodOptions: map(this.buildProfileDropdown, contactMethods.options),
          language: languages.default,
          languageOptions: map(this.buildProfileDropdown, languages.options),
          location: locations.default,
          locationOptions: map(this.buildProfileDropdown, locations.options),
          timeZone: timeZones.default,
          timeZoneOptions: map(this.buildProfileDropdown, timeZones.options),
        });

      }
    }

  }

  componentDidMount() {
    this.handleGetProfile();
  }

  updateValue = (att, value) => this.setState({ [att]: value });

  handleGetProfile = () => this.props.getProfile();

  handleSubmit = (e) => {
    e.preventDefault();

    const formValues = {
      username: this.state.username,
      email: this.state.email,
      home: this.state.home,
      cell: this.state.cell,
      optOut: this.state.optOut,
      contactMethod: this.state.contactMethod,
      language: this.state.language,
      location: this.state.location,
      timeZone: this.state.timeZone,
    };

    this.props.updateProfile(formValues);
  };

  isLoading = (loadingState) => contains(ProfileTypes.GET_PROFILE, loadingState.requests);

  // Make react-select figure its shit out - we must format the object to use these keys
  buildProfileDropdown = entry => ({ value: entry, label: entry.label });

  renderLoginDetails = () => {
    // Does their profile have login details hidden?
    if (!this.state || !this.props.profile || this.props.profile.hideLoginDetails) {
      return false;
    }

    // Believe these are seperated to avoid state updates causing a re-rendering of the other
    return (
      <div>
        <LoginInfo
          username={this.state.username}
          updateValue={this.updateValue}
        />

        <ChangePassword
          updatePassword={this.props.updatePassword}
          updateValue={this.updateValue}
        />
      </div>
    );
  };

  renderContactInfo = () => {
    if (!this.state || !this.props.profile) {
      return false;
    } else if (this.props.profile.hideFullContactInfo) {
      return (
        <ContactInfoBasic
          optOut={this.state.optOut}
          updateValue={this.updateValue}
        />
      );
    } else {
      return (
        <ContactInfo
          destinations={{
            email: this.state.email,
            home: this.state.home,
            cell: this.state.cell,
          }}
          labels={this.labels}
          contactMethod={this.state.contactMethod}
          contactMethodOptions={this.state.contactMethodOptions}
          optOut={this.state.optOut}
          updateValue={this.updateValue}
        />
      );
    }
  };

  renderAdditionalInfo = () => {
    if (!this.state || !this.props.profile || this.props.profile.hideAdditionalInfo) {
      return false;
    } else {

      const {
        language,
        location,
        languageOptions,
        locationOptions,
        timeZone,
        timeZoneOptions,
      } = this.state;

      return (
        <AdditionalInfo
          fields={{
            language: language,
            location: location,
            timeZone: timeZone,
          }}
          options={{
            language: languageOptions,
            location: locationOptions,
            timeZone: timeZoneOptions,
          }}
          labels={this.labels}
          updateValue={this.updateValue}
        />
      );
    }
  };

  render = () => {
    const isLoading = this.isLoading(this.props.loadingState);

    if (isLoading) {
      return (
        <div>
          <p className={s.message}>
            Loading your Profile information...
          </p>
          <LoadingState context="myProfile" />
        </div>
      );
    } else {
      return (
        <section className={cx(s.component, s.pageContainer)}>
          <h3 className={s.pageHeader}>
            To change your profile information, edit the text field or drop down and select Save.
          </h3>
          <form
            id="profileForm"
            className={s.formContainer}
            onSubmit={this.handleSubmit}
          >
            {this.renderLoginDetails()}

            {this.renderContactInfo()}

            {this.renderAdditionalInfo()}

            <div className={s.group}>
              <input
                id="profile__submit"
                type="submit"
                value="Save"
                className={s.btn}
              />
            </div>
          </form>
        </section>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  loadingState: state.loadingState,
  profile: state.profile,
});

const mapDispatchToProps = dispatch => ({
  getProfile: () => dispatch(getProfile()),
  updatePassword: (formValues, successCb) => dispatch(updatePassword(formValues, successCb)),
  updateProfile: (formValues) => dispatch(updateProfile(formValues)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);



// WEBPACK FOOTER //
// ./src/components/Pages/Account/Profile/Profile.js